module.exports = "/assets/data/037823d1131ed099a58281fed21c87ad-HS1.data.json";